import { render, staticRenderFns } from "./ButtonsBlock.vue?vue&type=template&id=7f26abc7&scoped=true&"
import script from "./ButtonsBlock.vue?vue&type=script&lang=js&"
export * from "./ButtonsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f26abc7",
  null
  
)

export default component.exports